import { NoteEditIcon } from './NoteEditIcon';

/**
 * author: Colton Wiscombe
 * id 80075448-6EB3-4318-9887-6C199DB9A86E
 * name note-edit
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-edit.svg
 * tags
 * - Edit / Modify 
 */
export const PaperEditIcon = NoteEditIcon;
export default PaperEditIcon